import styled from "styled-components";
import {ReactUtils} from "../../utils/ReactUtils";
import {IconButtonV5} from "../interaction/IconButtonV5";
import EyeIcon from "../icons/eye-alt.svg?react";
import CancelIcon from "../icons/xmark-large.svg?react";
import LockedIcon from "../icons/lock-icon-locked.svg?react";
import UnlockedIcon from "../icons/lock-icon-unlocked.svg?react";
import {Functions} from "../../../utils/function/Functions";
import {baseDistance} from "../styles/styles";
import type {LayerType} from "../../../data/models/ViewUtils";
import {colorPalette} from "../styles/colorPalette";

interface IHideAndLockProps {
	readonly type: LayerType;
	readonly isActive: boolean;
	readonly onChange: (active: boolean) => void;
	readonly isItForModifyAll?: boolean;
}

export const HideAndLockV5 = ({type, isActive, isItForModifyAll, onChange}: IHideAndLockProps) => {
	const title = type === "hide" ? (isActive ? "Show" : "Hide") : isActive ? "Unlock Position in View" : "Lock Position in View";
	const IconComponent = type === "hide" ? (isActive ? EyeIcon : CancelIcon) : isActive ? LockedIcon : UnlockedIcon;

	return (
		<HideAndLockStyled
			className={ReactUtils.cls("HideAndLock", {modifyAll: isItForModifyAll})}
			onClick={() => onChange(!isActive)}
			style={{color: isActive ? colorPalette.primary.c500Primary : "initial"}}
		>
			<IconButtonV5
				IconComponent={IconComponent}
				title={title}
				onClick={Functions.emptyFunction}
			/>
		</HideAndLockStyled>
	);
};

const HideAndLockStyled = styled.div`
	position: relative;
	padding-top: ${baseDistance.xs};
	cursor: pointer;

	.IconButton {
		min-width: 24px;
		height: 24px;
		color: inherit;
	}
`;
